<template>
  <div class="tabs-content">
    <el-tabs
      v-model="activeIndex"
      type="border-card"
      @tab-click="tabClick"
      @tab-remove="tabRemove"
      closable
      class="m-home-tab"
    >
      <el-tab-pane :key="index+item.text" v-for="(item, index) in options" :name="index.toString()">
        <span slot="label" @contextmenu.prevent="showCloseType(index.toString())">
          <span v-if="item.text==='首页'">
            <i class="el-icon-s-home"></i>
          </span>
          <span v-else>{{item.text}}</span>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="modal" @click="hiddenTabOption" v-if="showModal" @click.right="hiddenTabOption"></div>
    <div
      id="closee-tab-option"
      class="closee-tab-option"
      @click="closeTab"
      @click.right="(e)=>{e.preventDefault();}"
      v-show="closeTabOption"
    >
      <p>关闭左侧标签</p>
      <p>关闭右侧标签</p>
      <p>关闭其他标签</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      closeTabOption: false,
      showModal: false,
      operateTab: ""
    };
  },
  computed: {
    // 选项卡
    options() {
      return this.$store.state.options;
    },
    path() {
      return this.$route.fullPath;
    },
    menuList() {
      return this.$store.state.menuList;
    },
    // 当前选项卡
    activeIndex: {
      get() {
        return this.$store.state.activeIndex.toString();
      },
      set(val) {
        this.$store.commit("SET_ACTIVE_INDEX", Number(val));
      }
    }
  },
  // 监听路由改变tab状态
  watch: {
    $route(to, from) {
      if (to.meta && to.meta.hidden) {
        this.changeTabstate(to.matched[1].path);
        return;
      }
      this.changeTabstate(to.fullPath);
    }
  },
  mounted() {
    this.$store.commit("ADD_TAB", { path: "/", text: "首页" });
    // 页面刷新添加默认路由
    if (this.$route.meta && this.$route.meta.hidden) {
      this.changeTabstate(this.$route.matched[1].path);
      return;
    }
    this.changeTabstate(this.path);
  },
  methods: {
    // 解决url识别中+号被识别成空格的问题
    getfinalPath(path) {
      return unescape(path).replace(/\+/g, "%2B");
    },
    // 添加默认tab
    changeTabstate(path) {
      path = this.getfinalPath(path);
      if (this.path !== "/index") {
        let text = this.gettext(this.menuList, path);
        if (!text) return;
        this.$store.commit("ADD_TAB", { path: path, text: text });
        this.$store.commit("SET_ACTIVE_PATH", path);
      } else {
        this.$store.commit("SET_ACTIVE_INDEX", 0);
      }
    },
    // 根据path获取对应text
    gettext(data, path) {
      let text = "";
      try {
        const findtext = item => {
          if (item.path === path) {
            throw item.text;
          }
          if (item.list && item.list.length > 0) {
            for (let i in item.list) {
              findtext(item.list[i]);
            }
          }
        };
        for (let i in data) {
          findtext(data[i]);
        }
      } catch (name) {
        text = name;
      }
      return text;
    },
    // 点击标签,实现跳转
    tabClick() {
      for (let i = 0; i < this.options.length; i++) {
        if (i === Number(this.activeIndex)) {
          this.$router.push({ path: this.options[i].path });
        }
      }
    },
    // 删除标签
    tabRemove(index) {
      this.operateTab = index;
      if (index === "0") {
        return;
      }
      this.$store.commit("DEL_TAB", index);
      if (this.activeIndex === index) {
        // 设置当前激活的路由
        if (!this.options || this.options.length <= 1) {
          this.$store.commit("SET_ACTIVE_INDEX", 0);
          this.$router.push({ path: "/index" });
          return;
        }
        this.$store.commit("SET_ACTIVE_INDEX", this.options.length - 1);
        for (let i = 0; i < this.options.length; i++) {
          if (i === Number(this.activeIndex)) {
            this.$router.push({ path: this.options[i].path });
          }
        }
      } else {
        // 判断点亮标签是否在左侧;
        if (this.judgePosition()) {
          this.$store.commit("SET_ACTIVE_INDEX", Number(this.activeIndex) - 1);
        }
      }
    },
    closeLeftTab() {
      // 判断点亮标签是否在左侧;
      if (!this.judgePosition()) {
        this.setActiveTab();
      } else {
        this.$store.commit(
          "SET_ACTIVE_INDEX",
          Number(this.activeIndex) - Number(this.operateTab) + 1
        );
      }
      this.$store.commit("DEL_LEFT_TAB", Number(this.operateTab));
    },

    closeRightTab() {
      // 判断点亮标签是否在右侧;
      if (this.judgePosition()) {
        this.setActiveTab();
      }
      this.$store.commit("DEL_RIGHT_TAB", Number(this.operateTab));
    },

    closeOtherTab() {
      this.$store.commit("DEL_OTHER_TAB", Number(this.operateTab));
      this.operateTab = "1";
      this.setActiveTab();
    },

    // 设置当前操作的标签为当前点亮标签
    setActiveTab() {
      this.$store.commit("SET_ACTIVE_INDEX", Number(this.operateTab));
      for (let i = 0; i < this.options.length; i++) {
        if (i === Number(this.operateTab)) {
          this.$router.push({ path: this.options[i].path });
        }
      }
    },

    // 判断位置,点亮标签在左侧为false,在右侧true
    judgePosition() {
      let options = JSON.parse(JSON.stringify(this.options));
      for (let i = 0; i < this.options.length; i++) {
        if (i === Number(this.operateTab)) {
          return true;
        }
        if (i === Number(this.activeIndex)) {
          return false;
        }
      }
    },

    hiddenTabOption() {
      event.preventDefault();
      document.getElementById("closee-tab-option").style.display = "none";
      this.showModal = false;
    },

    // 右键出现关闭选项
    showCloseType(name) {
      if (name === "0") return;
      this.operateTab = name;
      let closeTabOption = document.getElementById("closee-tab-option");
      this.$nextTick(() => {
        closeTabOption.style.top = event.clientY + "px";
        closeTabOption.style.left = event.clientX + "px";
      });
      document.getElementById("closee-tab-option").style.display = "block";
      this.showModal = true;
    },

    // 选择关闭选项
    closeTab(e) {
      document.getElementById("closee-tab-option").style.display = "none";
      this.showModal = false;
      if (this.options && this.options.length === 2) return;
      let option = e.target.textContent;
      switch (option) {
        case "关闭左侧标签":
          this.closeLeftTab();
          break;
        case "关闭右侧标签":
          this.closeRightTab();
          break;
        case "关闭其他标签":
          this.closeOtherTab();
          break;
      }
    }
  }
};
</script>
<style lang='less' scoped>
.tabs-content {
  .closee-tab-option {
    position: fixed;
    width: 130px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    z-index: 904;
    padding: 0;

    p {
      padding: 0 20px;
      cursor: pointer;
    }

    p:hover {
      background-color: #f6f6f6;
    }
  }

  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
  }
}
</style>
<style lang='less'>
.tabs-content {
  .el-icon-s-home {
    font-size: 24px;
    line-height: 38px;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 0px;
  }

  .el-tabs__item:first-child .el-icon-close {
    display: none;
  }

  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    box-sizing: border-box;
    border-right: 1px solid #f6f6f6 !important;
  }
}
</style>